import { z } from 'zod';
import { OfferIdSchema } from './offer.js';

export const ME_DRAFT_OFFERS_LIMIT = 50;

const MeDraftOfferSchema = z
  .object({
    offerId: OfferIdSchema,
    title: z.string(),
    clientName: z.string().nullable(),
    unitCount: z.number().int().nonnegative(),
    lastUsed: z.boolean(),
  })
  .strict();

export const MeDraftOffersResponseSchema = z
  .object({
    drafts: z.array(MeDraftOfferSchema),
  })
  .strict();
export type MeDraftOffersResponse = z.infer<typeof MeDraftOffersResponseSchema>;

export const MeDraftOffersQuerySchema = z
  .object({
    limit: z.coerce.number().int().positive().max(ME_DRAFT_OFFERS_LIMIT).optional(),
  })
  .strict();
export type MeDraftOffersQuery = z.infer<typeof MeDraftOffersQuerySchema>;
